
import React from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const BrowsingHistory = () => {
  const navigate = useNavigate();
  
  return (
    <motion.div 
      className="text-center py-16"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <motion.div
          animate={{ 
            rotate: [0, 360],
            scale: [1, 1.1, 1]
          }}
          transition={{ 
            duration: 3,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          <Clock className="h-12 w-12 mx-auto text-muted-foreground" />
        </motion.div>
      </motion.div>
      
      <motion.h3 
        className="text-xl font-medium mt-4"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        No browsing history yet
      </motion.h3>
      
      <motion.p 
        className="text-muted-foreground mt-2"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        Your recently viewed careers, mentors, and resources
        will appear here for easy access.
      </motion.p>
      
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Button 
          variant="outline" 
          className="mt-6 transition-all duration-300 hover:bg-primary/10 hover:border-primary/30"
          onClick={() => navigate('/explore')}
        >
          Start Exploring
        </Button>
      </motion.div>
    </motion.div>
  );
};

export default BrowsingHistory;
